import { combineReducers } from "@reduxjs/toolkit";
import { notifyStepSlice } from "../slices/notifyStepSlice";

/* istanbul ignore next */
export const systemNotificationsReducer = combineReducers({
  notifyStep: notifyStepSlice.reducer,
});

export type SystemNotificationState = ReturnType<typeof systemNotificationsReducer>;
